import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useNotificationUiStore = defineStore('notificationUiStore', () => {
  const aiAnswersSnackbar = ref(false);

  function showAiAnswersSnackbar() {
    aiAnswersSnackbar.value = true;
  }

  return {
    aiAnswersSnackbar,
    showAiAnswersSnackbar
  }
});

